import React from 'react';
import LinkBranded, { LinkProps } from 'src/elements/links/2023_Q4/LinkBranded';
import IconsCallToActionArrow from 'src/images/IconsCallToActionArrow';

export type HeaderCtaType = 'standard' | 'pro';

interface HeaderCtaProps {
  callToAction: HeaderCtaType;
  callToActionLink: string;
  callToActionColorScheme: LinkProps['colorScheme'];
  callToActionText?: string;
  callToActionStatsigEvent?: string;
}

const HeaderCta = ({
  callToAction,
  callToActionLink,
  callToActionColorScheme = 'Sunshine',
  callToActionText,
  callToActionStatsigEvent,
}: HeaderCtaProps): JSX.Element => {
  const defaultCallToActionText = callToAction === 'pro' ? 'Get a Custom Demo' : 'Start Free Trial';
  const text = callToActionText ?? defaultCallToActionText;

  return (
    <LinkBranded
      text={text}
      url={callToActionLink}
      size='1rem'
      sizeSm='0.875rem'
      customFontWeight={700}
      statsigEvent={callToActionStatsigEvent}
      className='header-call-to-action'
      icon={
        <IconsCallToActionArrow
          color='greyText'
          width={15}
        />
      }
      colorScheme={callToActionColorScheme}
    />
  );
};
export default HeaderCta;
